import {useEffect, useState} from 'react';
import {CityWithIdItem, RegionItem} from '@/models';
import {useCommonStore} from '@/stores';

const useGetCitiesByRegion = (regionId?: string) => {
  const {getRegions, regions} = useCommonStore();

  useEffect(() => {
    if (!regions || regions?.length === 0) {
      getRegions();
    }
  }, []);

  const [cities, setCities] = useState<CityWithIdItem[]>([]);

  const getCitiesByRegionId = (regionId: string) => {
    const foundRegion = regions?.find(
      (region: RegionItem) => region.id === regionId
    );
    if (foundRegion) {
      setCities(foundRegion?.citiesWithIds);
    }
  };

  useEffect(() => {
    if (regionId) {
      getCitiesByRegionId(regionId);
    }
  }, [regionId]);

  return {
    regions,
    getCitiesByRegionId,
    cities,
  };
};

export default useGetCitiesByRegion;
